import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';


export const CardContainerDescription = ({titulo,descripcion}) => {
    return (
        <div className="card-container">
            <h3 className="card-title">{titulo}</h3>
            <div className="card-description">
                {descripcion}
            </div>
        </div>
    )
}
